import { icons } from '@shared/static/icons';
import { Avatar } from '@shared/ui/parts';
import { getCryptoName } from '@utils/balance-helpers';

export default function RenderItemTeam({ item }) {
  return (
    <div className="render-select-icon">
      {item?.slug && <Avatar team={item} />}
      {item?.label ? (icons[getCryptoName(item.value)] ?? null) : null}
      <div>
        <p className={item?.deleted_at ? 'tertiary-text' : ''}>
          {item?.name || item?.label}
        </p>
      </div>
    </div>
  );
}
